import React from 'react'

const StateManagementContext = React.createContext([])

export const StateManagementProvider = StateManagementContext.Provider
export const StateManagementConsumer = StateManagementContext.Consumer

export default StateManagementContext